// src/pages/ApplicationCatalogue.js
import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import ApplicationTable from "../../components/JobApplications/ApplicationTable";

export default function ApplicationCataloguePage() {
  // Prevent the document/body from adding an extra scrollbar
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  return (
    <Box flex="1" h="100%" overflowY="auto">
      <ApplicationTable />
    </Box>
  );
}
